<template>
<div>
    <Nav />
    <div class="pageWD shadowBox mT20 minHeight">
        <div class="mainTop f18 c3" >任务</div>
        
        <div class="task_list" style="margin-top:40px">
           <div class="flex f18 c3 tb_header">
              <div class="nr" style="padding-left:24px" >学习内容</div><div class="ls">主讲老师</div><div class="zt">状态</div><div class="jd">学习进度</div>
           </div>
           <div  v-for="(item,index) in taskItems" :key="index" >         
               <DetailItem :item="item" :state="state" :taskId="taskId"/>
           </div>
        </div>
        <div class="p24 flex">
            <div style="width:1085px" v-if="taskInfo">
            <div style="font-weight:bold">{{taskInfo.taskName}}</div>
            <div class="task_tip">
                <div class="f14" v-if="taskInfo.timeType == 0"><span class="c3">任务时间：</span><span class="c9">15天内</span></div>
                <div class="f14" v-if="taskInfo.timeType == 1"><span class="c3">任务时间：</span><span class="c9">{{ $conFun.parseData(taskInfo.begin) }} 至 {{ $conFun.parseData(taskInfo.eTime) }}</span></div>
                <div class="f14" v-if="taskInfo.timeType == 2"><span class="c3">任务时间：</span><span class="c9"> 不限时</span></div>
                <div class="f14"><span class="c3">创建人：</span><span class="c9">{{taskInfo.createBy}}</span></div>
            </div>
            <div class="f14 c9" v-if="taskInfo.desc" v-html="taskInfo.desc"></div>
            </div> 
            <!-- <div class="prog"> 
                <el-progress type="circle" :percentage="percentage" :width="cirWidth" ></el-progress>
                <span style="position:absolute; font-size:14px; color:#999;width:100%; text-align:center;right:0;top:35px" >总进度</span>
            </div> -->
        </div>
    </div>
</div>
</template>
<script>
import Cookies from "js-cookie";
import Nav from "@/components/Nav.vue";
import { getTaskInfo  } from '@/api/api'

import DetailItem from "./components/DetailItem.vue";
  export default {
    components: { Nav ,DetailItem},
    data() {
        return {
            taskId:this.$route.query.taskId,
            state:this.$route.query.state,
            cirWidth:74,
            percentage:20,           
            taskInfo:null,
            taskItems:null          
        }
    },
    created() {
        this.getTaskInfoFun()
    },
    methods: {
       
        getTaskInfoFun() {
          var that = this;
          let data = {
              memberId: Cookies.get('qslmemberId'),
              taskId: that.taskId,          
          };
          getTaskInfo(data)
              .then(res => {
                  console.log( res.body.result ) 
                  that.taskInfo = res.body.result.taskInfo
                  that.taskItems = res.body.result.taskItems
              })
              .catch(err => {});
        }
    }
  }
  </script>
  <style>
  .prog{
       position:relative;
  }
  .prog .el-progress--circle .el-progress__text, .el-progress--dashboard .el-progress__text{
      top:40%
  }
   .task_list .el-progress__text{
       color:#999;
       font-size:14px
   }
      .task_list .el-progress-bar__outer
   {
       background:#f3f4f7
   }
   .task_list .el-progress-bar__inner{
       background:#4B9AFB
   }
  .task_tip{
      padding:18px 0;
      line-height:30px
  }
  .tb_header{
      background: #f3f4f7;
      border-radius: 8px 8px 0px 0px;
      height:64px;
      line-height:64px;
      margin:0 24px
  }

  .task_list .nr{
    flex:1;   
  }
  .task_list .nr .img{
    width:16px; 
    margin-right:18px  
  }
 .task_list .ls{
    width:165px;
     
  }
  .task_list .zt{
      width:165px;     
  }
  .task_list i{    
      width:18px; 
      font-size:20px;
      margin-right:15px
  }
  .task_list .jd{
     width:240px;
  }


  </style>


// WEBPACK FOOTER //
// src/views/Task/Detail.vue